var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.818 9.84a1.135 1.135 0 0 0-1.135 1.137 8.708 8.708 0 0 1-13.698 7.13C2.053 15.354 1.094 9.915 3.847 5.984 6.6 2.052 12.038 1.093 15.97 3.846a8.71 8.71 0 0 1 1.61 1.453h-3.196a1.135 1.135 0 0 0 0 2.27h5.299c.627 0 1.135-.507 1.135-1.135V1.135a1.135 1.135 0 1 0-2.27 0v1.891a11.08 11.08 0 0 0-1.275-1.04 10.976 10.976 0 1 0-12.59 17.98 10.895 10.895 0 0 0 6.271 1.989 11.117 11.117 0 0 0 1.93-.17 10.978 10.978 0 0 0 9.07-10.81c0-.626-.51-1.134-1.136-1.134z"
  })));
};
export default SvgReload;